exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkmark[data-v-29dd0aed] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  margin-left: 15px;\n}\n.checkmark[data-v-29dd0aed]::after {\n  content: \"\";\n  display: block;\n  width: 10px;\n  height: 18px;\n  margin-top: -10px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}", ""]);

// exports
